// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const domainCreditsDto = {
    domainGuid: 'domainGuid',
    name: 'name',
    isOwner: 'isOwner',
    canPurchase: 'canPurchase',
    creditBalance: 'creditBalance',
    creditLimit: 'creditLimit',
    spent: 'spent',
    expectedCharge: 'expectedCharge',
    required: 'required',
    available: 'available',
    billingState: 'billingState',
    billingStateSince: 'billingStateSince',
    billingGraceUntil: 'billingGraceUntil',
    cleanupFrom: 'cleanupFrom',
    archived: 'archived',
    billingAddress: 'billingAddress',
    vatNumber: 'vatNumber',
    billingEmail: 'billingEmail',
    ownerEmail: 'ownerEmail',
    creditPrice: 'creditPrice',
    vatPerc: 'vatPerc',
    purchaseBundleCredits: 'purchaseBundleCredits',
    paymentOnline: 'paymentOnline',
    billingStartPeriod: 'billingStartPeriod',
} as const;

export type TDomainCreditsDto = (typeof domainCreditsDto)[keyof typeof domainCreditsDto];

export interface IDomainCreditsDto {
    [domainCreditsDto.domainGuid]: string | null;
    [domainCreditsDto.name]: string | null;
    [domainCreditsDto.isOwner]: boolean | null;
    [domainCreditsDto.canPurchase]: boolean | null;
    [domainCreditsDto.creditBalance]: number | null;
    [domainCreditsDto.creditLimit]: number | null;
    [domainCreditsDto.spent]: number | null;
    [domainCreditsDto.expectedCharge]: number | null;
    [domainCreditsDto.required]: number | null;
    [domainCreditsDto.available]: number | null;
    [domainCreditsDto.billingState]: string | null;
    [domainCreditsDto.billingStateSince]: string | null;
    [domainCreditsDto.billingGraceUntil]: string | null;
    [domainCreditsDto.cleanupFrom]: string | null;
    [domainCreditsDto.archived]: boolean | null;
    [domainCreditsDto.billingAddress]: string | null;
    [domainCreditsDto.vatNumber]: string | null;
    [domainCreditsDto.billingEmail]: string | null;
    [domainCreditsDto.ownerEmail]: string | null;
    [domainCreditsDto.creditPrice]: number | null;
    [domainCreditsDto.vatPerc]: number | null;
    [domainCreditsDto.purchaseBundleCredits]: number | null;
    [domainCreditsDto.paymentOnline]: boolean | null;
    [domainCreditsDto.billingStartPeriod]: string | null;
}

export class DomainCreditsDto
    implements IDomainCreditsDto
{
    [domainCreditsDto.domainGuid]: string | null = null;
    [domainCreditsDto.name]: string | null = null;
    [domainCreditsDto.isOwner]: boolean | null = null;
    [domainCreditsDto.canPurchase]: boolean | null = null;
    [domainCreditsDto.creditBalance]: number | null = null;
    [domainCreditsDto.creditLimit]: number | null = null;
    [domainCreditsDto.spent]: number | null = null;
    [domainCreditsDto.expectedCharge]: number | null = null;
    [domainCreditsDto.required]: number | null = null;
    [domainCreditsDto.available]: number | null = null;
    [domainCreditsDto.billingState]: string | null = null;
    [domainCreditsDto.billingStateSince]: string | null = null;
    [domainCreditsDto.billingGraceUntil]: string | null = null;
    [domainCreditsDto.cleanupFrom]: string | null = null;
    [domainCreditsDto.archived]: boolean | null = null;
    [domainCreditsDto.billingAddress]: string | null = null;
    [domainCreditsDto.vatNumber]: string | null = null;
    [domainCreditsDto.billingEmail]: string | null = null;
    [domainCreditsDto.ownerEmail]: string | null = null;
    [domainCreditsDto.creditPrice]: number | null = null;
    [domainCreditsDto.vatPerc]: number | null = null;
    [domainCreditsDto.purchaseBundleCredits]: number | null = null;
    [domainCreditsDto.paymentOnline]: boolean | null = null;
    [domainCreditsDto.billingStartPeriod]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IDomainCreditsData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[domainCreditsDto.guid] = modelData[domaincreditsData.guid];
    }

    static create(modelData?: any | null): IDomainCreditsDto | null {
        return modelData ? new DomainCreditsDto(modelData) : null;
    }
}
